import React, {useRef, useState} from 'react';
import { useDispatch } from 'react-redux';
import { usePopup } from '../../context/PopupContext';
import { duplicateResume as duplicateResumeAction } from '../../services/actions/actions';

const DuplicatePopup = (props) => {
    const dispatch = useDispatch();
    const { boxContent, close, status, rightCallbackAction, leftCallbackAction, data, waiting, setWaiting } = usePopup();
    const [newResumeName, setNewResumeName] = useState('');

    const getResumeName = () => {
        let resumeName = '';
        if (window.location.pathname === '/') {
            resumeName = localStorage.getItem('resumeName');
        } else {
            const fullname = (
                data.resume.heading.fname != ""
                    ? data.resume.heading.fname +
                    (
                        data.resume.heading.lname != ""
                            ? "_" + data.resume.heading.lname
                            : ''
                    )
                    : "Resume_Draft"
            );
            resumeName = (
                (data.resume.hasOwnProperty('resume_name')
                    && data.resume.resume_name != '')
                    ? data.resume.resume_name
                    : fullname.replace(/\s/g, "_")
            );
        }
        setNewResumeName(`${resumeName}_Copy`);
        //return resumeName;
    }

    const changeResumeName = (e) => {
        setNewResumeName(e.target.value);
    }

    const generateDuplicate = () => {
        dispatch(duplicateResumeAction(data.resume.id, newResumeName, 'currentResume')).then(res => {
        });
    }

    const ref = useRef(null);

    const getDuplicate = () => {
        if(!ref.current || ref.current != data.resume.id){
            ref.current = data.resume.id;
            getResumeName();
        }
    }
    
    if(status('duplicatebox')) getDuplicate();

    return (<>
        {status('duplicatebox') && <><div className="transparent-popup-bg"></div>
            <div className="custom-skip-popup">
                <div className="close-btn-icon">
                    <button className="close-icon"
                        onClick={() => {
                            close();
                        }}>Close</button>
                </div>
                <div className="content-box">
                    <h4>Choose a Name</h4>
                    <div className="download-icons-area">
                        <ul className="download-icons-list">
                            <li>
                                <input 
                                    id="resume_format" 
                                    type="text" 
                                    name="duplicate" 
                                    value={newResumeName} 
                                    onChange={ e => changeResumeName(e) }
                                />
                            </li>
                        </ul>
                    </div>
                    <div className="button-area">
                        <button className="no-skip" onClick={() => {
                            leftCallbackAction();
                        }}>Cancel</button>
                        <button className="skip" onClick={() => {
                            generateDuplicate();
                            rightCallbackAction();
                        }}>Save</button>
                    </div>
                </div>
            </div></>}
    </>)
}
export default DuplicatePopup;

